import { __decorate } from "tslib";
import { Component, Vue, Ref } from 'vue-property-decorator';
import SpeedChart from './components/speed-chart.vue';
import NumbersChart from './components/numbers-chart.vue';
import { GethistorySummary, GethistoryPass, GethistoryPassTime } from '@blade-sxp/monitor/api/queue/index';
import moment from 'moment';
import { dateFormat } from '@blade/common/utils/filters';
import { QueueModule } from '@blade-sxp/monitor/store/queue';
let default_1 = class default_1 extends Vue {
    lineChart;
    speedRef;
    totalTime = [];
    area = '';
    queueDate = '7';
    dailyDate = '7';
    dateEnd = '';
    dateStart = '';
    dataSeries = [];
    dataX = [];
    historyTotal = [];
    speed = [];
    timeIntervalType = 'DAY';
    speedUnit = '';
    rtime = +new Date();
    numCharts = false;
    speedCharts = false;
    pass = {
        dateEnd: '',
        dateStart: '',
    };
    passTime = {
        dateEnd: '',
        dateStart: '',
    };
    halfYear = '';
    areaList = [];
    get dateList() {
        return [
            {
                label: this.$t('week'),
                value: '7',
            },
            {
                label: this.$t('month'),
                value: '30',
            },
            {
                label: this.$t('halfYear'),
                value: '182',
            },
            {
                label: this.$t('year'),
                value: '365',
            },
        ];
    }
    passArr = [];
    passTimeArr = [];
    pollingNum;
    computeInterval = (num) => {
        if (num <= 10)
            return 0;
        return Math.floor((num - 1) / 10);
    };
    interval = 0;
    async mounted() {
        this.getInterval();
        await this.getTypes();
        this.gethistorySummary();
        // this.gethistoryPass(data);
        // this.gethistoryPassTime(data);
        this.initPolling();
    }
    initPolling() {
        this.pollingNum = setInterval(this.gethistorySummary, 1000 * 60);
    }
    getInterval() {
        const oneMonth = new Date();
        const currDate = dateFormat(oneMonth, 'YYYY-MM-DD');
        oneMonth.setMonth(oneMonth.getMonth() - 1);
        const oneDate = dateFormat(oneMonth, 'YYYY-MM-DD');
        this.totalTime = [new Date(oneDate), new Date(currDate)];
    }
    async getTypes() {
        try {
            const res = await QueueModule.getTaskTypes();
            this.areaList = res?.data;
            this.area = this.areaList[0].taskId;
            // this.areaList.unshift({
            //   deviceId: '',
            //   deviceName: this.$t('all'),
            // });
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    changeArea() {
        if (this.totalTime) {
            this.dateEnd = this.totalTime[1];
            this.dateStart = this.totalTime[0];
        }
        this.rtime = +new Date();
    }
    changeTime() {
        // console.log(this.totalTime);
        if (this.totalTime) {
            this.dateEnd = this.totalTime[1];
            this.dateStart = this.totalTime[0];
        }
        else {
            this.dateEnd = '';
            this.dateStart = '';
        }
        this.rtime = +new Date();
    }
    clearTime() {
        this.totalTime = [];
        if (this.pollingNum) {
            clearInterval(this.pollingNum);
        }
    }
    getTimeByInterval(interval) {
        const parseNum = interval ? Number(interval) : 0;
        const cc = new Date().getTime();
        var timeMilli = parseNum * 24 * 3600 * 1000;
        var pastResult = cc - timeMilli;
        return moment(pastResult).format('YYYY-MM-DD HH:mm:ss');
    }
    handleSearch() {
        this.dataSeries = [];
        this.dataX = [];
        this.speed = [];
        this.timeIntervalType = 'DAY';
        this.speedUnit = '';
        this.gethistorySummary();
        if (this.pollingNum) {
            clearInterval(this.pollingNum);
            this.initPolling();
        }
    }
    gethistorySummary() {
        let data = {
            dateEnd: dateFormat(this.totalTime[1], 'YYYY-MM-DD') ? `${dateFormat(this.totalTime[1], 'YYYY-MM-DD')} 23:59:59` : '',
            dateStart: dateFormat(this.totalTime[0], 'YYYY-MM-DD') ? `${dateFormat(this.totalTime[0], 'YYYY-MM-DD')} 00:00:00` : '',
            groupByTimeIntervalType: '',
            queueTaskId: this.area,
        };
        this.numCharts = false;
        this.speedCharts = false;
        this.getHistoryS(data);
    }
    getHistoryS(data) {
        GethistorySummary(data)
            .then(res => {
            let info = res.data.data.summary.list;
            this.historyTotal = info;
            if (info.length === 0) {
                return;
            }
            const queueArr = [];
            const abandonArr = [];
            const averageTimeArr = [];
            const dataX = [];
            info.forEach((item) => {
                queueArr.push(item.queueingCount);
                abandonArr.push(item.predictionQueuingTime);
                averageTimeArr.push(item.speedRatio.speed);
                dataX.push(item.date);
                this.speed.push(item.speedRatio.speed);
            });
            this.dataX = JSON.parse(JSON.stringify(dataX));
            this.dataSeries = [queueArr, abandonArr, averageTimeArr];
            this.timeIntervalType = info[0].timeIntervalType;
            // this.timeIntervalType = 'MIN';
            this.speedUnit = info[0].speedRatio.speedUnit;
            console.log(res, this.timeIntervalType, this.speedUnit, 'this.timeIntervalType');
            this.numCharts = true;
            this.speedCharts = true;
            // this.interval = this.computeInterval(this.dataX.length);
        })
            .catch(e => {
            console.log('e:', e);
        });
    }
    changeDaliyDate() {
        console.log('daily date:', this.dailyDate);
        const data = { dateEnd: this.getTimeByInterval('0'), dateStart: this.getTimeByInterval(this.dailyDate) };
        this.gethistoryPass(data);
    }
    clearDailyDate() {
        const data = { dateEnd: '', dateStart: '' };
        this.gethistoryPass(data);
    }
    changeQueueDate() {
        console.log('queue date:', this.queueDate);
        const data = { dateEnd: this.getTimeByInterval('0'), dateStart: this.getTimeByInterval(this.queueDate) };
        this.gethistoryPassTime(data);
    }
    clearQueueDate() {
        this.queueDate = '';
    }
    gethistoryPassTime(data) {
        GethistoryPassTime(data)
            .then(res => {
            this.passTimeArr = res.data.data.list;
            if (this.passTimeArr.length === 0)
                return;
            let maxNum = this.passTimeArr[0].value;
            this.passTimeArr = this.passTimeArr.map((item) => {
                let progressNum = 0;
                progressNum = (item.value / maxNum) * 100;
                progressNum = Math.floor(progressNum);
                let passTime = item.value.toFixed(2);
                return {
                    ...item,
                    progressNum: progressNum,
                    passTime: passTime,
                };
            });
        })
            .catch(e => {
            console.log('e:', e);
        });
    }
    gethistoryPass(data) {
        GethistoryPass(data)
            .then(res => {
            this.passArr = res.data.data.list;
            if (this.passArr.length === 0)
                return;
            let maxNum = this.passArr[0].value;
            this.passArr = this.passArr.map((item) => {
                let progressNum = 0;
                progressNum = (item.value / maxNum) * 100;
                progressNum = Math.floor(progressNum);
                return {
                    ...item,
                    progressNum: progressNum,
                };
            });
        })
            .catch(e => {
            console.log('e:', e);
        });
    }
    updateChart(start, end) {
        this.dateStart =
            start.split(' ').length <= 1 ? `${dateFormat(start, 'YYYY-MM-DD')} 00:00:00` : dateFormat(start, 'YYYY-MM-DD HH:mm:ss');
        this.dateEnd = end.split(' ').length <= 1 ? `${dateFormat(end, 'YYYY-MM-DD')} 23:59:59` : dateFormat(end, 'YYYY-MM-DD HH:mm:ss');
        // this.totalTime = [this.dateStart, this.dateEnd];
        // this.timeIntervalType = 'MINUTE';
        this.getHistoryS({ dateStart: this.dateStart, dateEnd: this.dateEnd, groupByTimeIntervalType: '', queueTaskId: this.area });
        if (this.pollingNum) {
            clearInterval(this.pollingNum);
            this.pollingNum = setInterval(() => {
                this.getHistoryS({
                    dateStart: this.dateStart,
                    dateEnd: this.dateEnd,
                    groupByTimeIntervalType: '',
                    queueTaskId: this.area,
                });
            }, 1000 * 60);
        }
    }
    handleDataZoomChange(timeStart, timeEnd) {
        const start = moment(timeStart);
        const end = moment(timeEnd);
        const m = end.diff(start, 'm');
        const days = Math.floor(m / (24 * 60));
        const hours = Math.floor(m / 60);
        if ((this.timeIntervalType === 'MINUTE' && hours > 5) ||
            (this.timeIntervalType === 'HOUR' && (days > 5 || hours <= 5)) ||
            (this.timeIntervalType === 'DAY' && days <= 5)) {
            this.updateChart(timeStart, timeEnd);
        }
    }
    beforeDestroy() {
        clearInterval(this.pollingNum);
        this.pollingNum = undefined;
    }
};
__decorate([
    Ref()
], default_1.prototype, "lineChart", void 0);
__decorate([
    Ref()
], default_1.prototype, "speedRef", void 0);
default_1 = __decorate([
    Component({
        components: {
            SpeedChart,
            NumbersChart,
        },
        i18n: {
            messages: {
                'en-us': {
                    startTime: 'Start Date',
                    endTime: 'End Date',
                    selectArea: 'Select queuing area',
                    queuingTime: 'Queuing time',
                    daily: 'Average daily reception',
                    filter: 'Filter',
                    week: 'Nearly a week',
                    month: 'Nearly a month',
                    halfYear: 'Nearly half a year',
                    year: 'Nearly a year',
                    noData: 'No Data...',
                    all: 'All',
                },
                zh: {
                    startTime: '开始日期',
                    endTime: '结束日期',
                    selectArea: '选择排队区域',
                    queuingTime: '排队时长',
                    daily: '日均接待人数',
                    filter: '筛选',
                    week: '近一个星期',
                    month: '近一个月',
                    halfYear: '近半年',
                    year: '近一年',
                    noData: '暂无数据',
                    all: '全部',
                },
            },
        },
    })
], default_1);
export default default_1;
